import type { ButtonProps } from "@gearbox-protocol/deploy-tools-ui";
import {
  Button,
  DotsVertical,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";
import { Link } from "react-router-dom";
import { useToggle } from "react-use";

import DeleteDialog from "./DeleteDialog";

interface TaskDefinitionDropdownMenuProps extends ButtonProps {
  definitionId: string;
}

export const TaskDefinitionDropdownMenu: FC<
  TaskDefinitionDropdownMenuProps
> = props => {
  const { definitionId, ...buttonProps } = props;
  const [killDialogOpen, toggleKillDialog] = useToggle(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" {...buttonProps}>
            <DotsVertical />
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent className="w-56">
          <DropdownMenuItem asChild>
            <Link to={`/task-definitions/${definitionId}/edit`}>Update</Link>
          </DropdownMenuItem>

          <DropdownMenuItem asChild disabled>
            <Link to={`/task-definitions/new?clone=${definitionId}`}>
              Clone
            </Link>
          </DropdownMenuItem>

          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={toggleKillDialog}>Delete</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <DeleteDialog
        definitionId={definitionId}
        open={killDialogOpen}
        onOpen={toggleKillDialog}
      />
    </>
  );
};
